import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface ISearchButtonProps extends ICustomButtonProps {}

export const SearchButton: React.FunctionComponent<ISearchButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.SEARCH}
      minimal={minimal}
      onClick={onClick}
      text={minimal ? null : t(ETLCodes.SearchCriteriaPanel_Search)}
      intent={intent}
      loading={loading}
      disabled={disabled}
      type={"button"}
    />
  );
};
